import React from 'react';
import { Alert } from 'antd';
import BootstrapSpinner from 'react-bootstrap/Spinner';
import { Colors } from '../../../../themes/colors';
import { formatPromotionDate } from '../../ProPrograms/utils';
import { COLORS } from '../../ProPrograms/constants';
import { useProfessionalPromotionPayouts } from './hooks/useProfessionalPromotionPayouts';

// The BE status enum → the copy shown to admins (a succeeded transfer reads
// as "Paid" per the design).
const STATUS_LABELS = {
  queued: 'Pending',
  succeeded: 'Paid',
  failed: 'Failed',
  skipped: 'Skipped',
};

const cellStyle = { padding: '10px 15px', fontSize: 14, color: Colors.neutral_800 };
const headerCellStyle = { ...cellStyle, fontWeight: 700 };

export const ProfessionalPromotionPayouts = () => {
  const { payouts, isLoading, isError } = useProfessionalPromotionPayouts();

  return (
    <div style={{ maxWidth: 900, margin: '24px auto 0' }}>
      <h3 style={{ textAlign: 'center', color: Colors.neutral_800, marginBottom: 16 }}>
        Promotion Payout
      </h3>

      {isLoading && (
        <div style={{ padding: 24, textAlign: 'center' }}>
          <BootstrapSpinner animation="border" variant="info" role="status" />
        </div>
      )}

      {isError && (
        <Alert
          type="error"
          message="Unable to load promotion payouts"
          description="The service may be unavailable. Please try again later."
        />
      )}

      {!isLoading && !isError && payouts.length === 0 && (
        <div style={{ padding: '16px 15px', color: Colors.neutral_800, fontSize: 14 }}>
          No promotion payouts yet.
        </div>
      )}

      {!isLoading && !isError && payouts.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: COLORS.headerBg, textAlign: 'left' }}>
              <th style={headerCellStyle}>Date</th>
              <th style={headerCellStyle}>Promotion</th>
              <th style={headerCellStyle}>Amount</th>
              <th style={headerCellStyle}>Status</th>
            </tr>
          </thead>
          <tbody>
            {payouts.map((payout, index) => {
              // Append-only audit rows have no unique id; the list is read-only
              // and never reordered, so position is a stable key.
              // eslint-disable-next-line react/no-array-index-key
              const rowKey = `${payout.promotionName}-${payout.processedAt}-${index}`;

              return (
                <tr
                  key={rowKey}
                  style={{ borderBottom: `1px solid ${Colors.divider}` }}
                >
                  <td style={cellStyle}>{formatPromotionDate(payout.processedAt)}</td>
                  <td style={cellStyle}>{payout.promotionName}</td>
                  <td style={cellStyle}>{payout.amountDisplay}</td>
                  <td style={cellStyle}>
                    {STATUS_LABELS[payout.status] || payout.status}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};
